import { isMobile } from "../common/utils";
import Swiper from "swiper";
import { Navigation } from "swiper/modules";

const initialize = async (sectionData) => {
  const mobile = isMobile();
  const swiper = new Swiper(`#shopify-section-${sectionData.id} .gd-swiper`, {
    modules: [Navigation],
    loop: true,
    slidesPerView: 3,
    spaceBetween: 32,
    breakpoints: {
      0: {
        slidesPerView: 1,
        spaceBetween: 40,
      },
      801: {
        slidesPerView: 3,
        spaceBetween: 16,
      },
      1024: {
        slidesPerView: 3,
        spaceBetween: 32,
      },
    },
    navigation: {
      nextEl: `#shopify-section-${sectionData.id} .swiper-button-next`,
      prevEl: `#shopify-section-${sectionData.id} .swiper-button-prev`,
    },
  });
};

/*
 * main
 */

document.addEventListener("DOMContentLoaded", () => {
  if (window.gd.template != "index" || !window.gd.sections) {
    return;
  }
  const sectionData = window.gd.sections.find((s) => s.type == "top-pickup");
  if (!sectionData) {
    return;
  }
  initialize(sectionData);
});
